{
  "id": "anchor-fail",
  "text": "TIP_RESTRAINT \u00b7 UNANCHORED",
  "variant": "fail",
  "src": "/proof/video/anchor-fail.mp4",
  "poster": "/proof/video/anchor-fail-poster.jpg",
  "posterTime": 4.5,
  "duration": 6.0,
  "fps": 24.0,
  "keyframes": [
    {
      "t": 0.0,
      "top": 0.2384,
      "left": 0.4143,
      "width": 0.3375,
      "height": 0.5373
    },
    {
      "t": 0.5,
      "top": 0.2438,
      "left": 0.4074,
      "width": 0.3365,
      "height": 0.5357
    },
    {
      "t": 1.0,
      "top": 0.251,
      "left": 0.4157,
      "width": 0.3354,
      "height": 0.534
    },
    {
      "t": 1.5,
      "top": 0.2529,
      "left": 0.4199,
      "width": 0.3347,
      "height": 0.5328
    },
    {
      "t": 2.0,
      "top": 0.2468,
      "left": 0.42,
      "width": 0.3346,
      "height": 0.5327
    },
    {
      "t": 2.5,
      "top": 0.2428,
      "left": 0.4284,
      "width": 0.3345,
      "height": 0.5326
    },
    {
      "t": 3.0,
      "top": 0.2446,
      "left": 0.4322,
      "width": 0.3346,
      "height": 0.5327
    },
    {
      "t": 3.5,
      "top": 0.247,
      "left": 0.4214,
      "width": 0.3353,
      "height": 0.5337
    },
    {
      "t": 4.0,
      "top": 0.2479,
      "left": 0.4166,
      "width": 0.3359,
      "height": 0.5347
    },
    {
      "t": 4.5,
      "top": 0.2477,
      "left": 0.4175,
      "width": 0.337,
      "height": 0.5364
    },
    {
      "t": 5.0,
      "top": 0.2478,
      "left": 0.4104,
      "width": 0.3374,
      "height": 0.5372
    },
    {
      "t": 5.5,
      "top": 0.2448,
      "left": 0.4108,
      "width": 0.3381,
      "height": 0.5383
    },
    {
      "t": 5.958,
      "top": 0.2394,
      "left": 0.4216,
      "width": 0.3381,
      "height": 0.5383
    }
  ]
}
